import _find from 'lodash/find';
import {stringTool} from '../../../util/string-tool.js';

export default class EditFullAttendanceController {
  /** @ngInject */
  constructor(
    $log, $rootScope, $mdDialog, $mdToast, $document, attendance, categoriesOfDeparture, moment,
    StudentService,
    EmployeeService,
    UtilService
  ) {
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$document = $document;
    this.attendance = attendance;
    this.categoriesOfDeparture = categoriesOfDeparture;
    this.moment = moment;
    this.StudentService = StudentService;
    this.EmployeeService = EmployeeService;
    this.UtilService = UtilService;
    this.StringTool = stringTool;

    this.employees = [];
    this.startTime = this.moment(this.UtilService.parseTime(this.attendance.startTime)).format('HH:mm');
    this.endTime = this.moment(this.UtilService.parseTime(this.attendance.endTime)).format('HH:mm');
    this.date = this.moment(this.attendance.date).toDate();
    this.departureCategory = this.attendance.categoryOfDepartureId;

    if (this.attendance.categoryOfDepartureId) {
      this.departureCategoryName = this.categoriesOfDeparture.filter(item => item.id === this.attendance.categoryOfDepartureId)[0].description || '';
    }

    this.loadEmployees();
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.attendance.date = this.moment(this.date).format('YYYY-MM-DD');
    this.attendance.startTime = this.startTime;
    this.attendance.endTime = this.endTime;
    this.attendance.categoryOfDepartureId = this.departureCategory;
    if (Number(this.attendance.categoryOfDepartureId) === 2 && this.selectedEmployee) {
      this.attendance.receivingEmployeeId = Number(this.selectedEmployee.id);
    }

    return this.StudentService.editAttendance(this.attendance)
      .then(() => {
        this.attendance.invalid = false;
        this.$mdDialog.hide(this.attendance);
      })
      .catch(error => {
        this.$mdDialog.cancel();
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  loadEmployees() {
    if (this.departureCategory) {
      const category = _find(this.categoriesOfDeparture, category => category.id === this.departureCategory);
      if (!category.isTransfer) {
        return false;
      }
    }

    this.EmployeeService.getSchoolCommonRoomActiveEmployees(0, true).then(result => {
      result.map(employee => {
        employee.firstNameValue = employee.firstName.toLowerCase();
        employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
        employee.lastNameValue = employee.lastName.toLowerCase();
        employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
        employee.fullNameValue = employee.fullName.toLowerCase();
        employee.fullNameValue = this.StringTool.escapePolishCharacters(employee.fullNameValue);
        return employee;
      });
      this.employees = result;

      if (this.attendance.receivingEmployeeId) {
        this.selectedEmployee = _find(this.employees, employee => employee.id === Number(this.attendance.receivingEmployeeId));
      }
    });
  }

  querySearch(query) {
    return query ? this.employees.filter(this.createFilterFor(query)) : this.employees;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return employee => {
      if (employee.lastNameValue.search(lowercaseQuery) === 0) {
        result = (employee.lastNameValue.search(lowercaseQuery) === 0);
      } else if (employee.firstNameValue.search(lowercaseQuery) === 0) {
        result = (employee.firstNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (employee.fullNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
